module.exports = __webpack_public_path__ + "static/img/1-1.817411a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/1-1.png
// module id = a1m6
// module chunks = 0